import { TIcons } from '@yuno/design-system-web'
import { useEffect, useState } from 'react'

export type SnackbarPosition = {
  horizontal: 'left' | 'center' | 'right'
  vertical: 'bottom' | 'top'
}
type SnackbarType = 'success' | 'error' | 'info'

interface Options {
  message: string
  position: SnackbarPosition
  type: SnackbarType
  width: string
  icon: TIcons
}
export type OpenSnackbar = (
  message: string,
  type: SnackbarType,
  icon?: TIcons,
  position?: SnackbarPosition,
  width?: string,
) => void

export const useSnackbar = () => {
  const [open, setOpen] = useState<boolean>(false)
  const [options, setOptions] = useState<Options>()
  useEffect(() => {
    if (options?.message) setOpen(true)
  }, [options])

  const onOpenSnackbar: OpenSnackbar = (
    message,
    type = 'success',
    icon = 'Info',
    position = { vertical: 'bottom', horizontal: 'center' },
    width,
  ) => {
    setOptions({ message, type, icon, width, position })
  }
  const onCloseSnackbar = () => setOpen(false)

  return {
    ...options,
    snackOpen: open,
    onCloseSnackbar,
    onOpenSnackbar,
  }
}
